import { useCallback, useRef } from 'react';

import _ from 'lodash';
import useStateRestore from './useStateRestore';

const useTableStateRestore = props => {
  const tableRef = useRef({});
  const { restoreState, forwardLink } = useStateRestore(props);

  const _forwardLink = useCallback(
    (path, forwardState, nested = true) =>
      forwardLink(path, forwardState, _.get(tableRef.current, 'settings'), nested),
    []
  );

  return {
    tableProps: { tableRef, state: restoreState },
    forwardLink: _forwardLink,
  };
};

export default useTableStateRestore;
